(()=>{'use strict';
const token='wib_arsenal_vault_v1';
function authorized(){try{return sessionStorage.getItem(token)==='unsealed'}catch(e){return false}}
function grant(){try{sessionStorage.setItem(token,'unsealed')}catch(e){}}
function revoke(){try{sessionStorage.removeItem(token)}catch(e){}}
const reduce=()=>window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
document.querySelectorAll('[data-vault-section]').forEach(section=>{
 const shell=section.querySelector('[data-vault-shell]');
 const content=section.querySelector('[data-vault-content]');
 if(!shell||!content)return;
 const form=shell.querySelector('[data-vault-form]');
 const input=shell.querySelector('[data-vault-password]');
 const status=shell.querySelector('[data-vault-feedback]');
 const button=shell.querySelector('[data-vault-unlock]');
 const relock=content.querySelector('[data-vault-relock]');
 let unlocking=false;
 function showOpen(){
   shell.hidden=true;content.hidden=false;
   section.classList.remove('arsenal-is-sealed');section.classList.add('arsenal-is-open');
   section.dataset.vaultStatus='open';
   input?.removeAttribute('aria-invalid');
 }
 function showSealed(){
   unlocking=false;shell.hidden=false;content.hidden=true;
   section.classList.remove('arsenal-is-open');section.classList.add('arsenal-is-sealed');
   section.dataset.vaultStatus='sealed';
   shell.classList.remove('vault-is-opening');
   if(input){input.value='';input.removeAttribute('aria-invalid')}
   if(status)status.textContent='AWAITING AUTHORIZATION / CODE REQUIRED';
   if(button)button.disabled=false;
 }
 function attempt(e){
   e.preventDefault();if(unlocking)return;
   if(!input||input.value.trim().toUpperCase()!=='BLIND'){
     if(input){input.setAttribute('aria-invalid','true');input.value='';input.focus()}
     if(status)status.textContent='ACCESS DENIED / INVALID CLEARANCE CODE';
     return;
   }
   unlocking=true;grant();
   input.removeAttribute('aria-invalid');
   if(status)status.textContent='CLEARANCE VERIFIED / RETRACTING VAULT LOCKS';
   if(button)button.disabled=true;
   shell.classList.add('vault-is-opening');
   const finish=()=>{showOpen();unlocking=false;const title=content.querySelector('h2');if(title){title.setAttribute('tabindex','-1');title.focus({preventScroll:true})}};
   if(reduce())finish();else window.setTimeout(finish,1050);
 }
 form?.addEventListener('submit',attempt);
 input?.addEventListener('input',()=>{input.removeAttribute('aria-invalid');if(status)status.textContent='VERIFYING / AWAITING FULL CLEARANCE CODE'});
 relock?.addEventListener('click',()=>{revoke();showSealed();shell.scrollIntoView({behavior:reduce()?'auto':'smooth',block:'center'});window.setTimeout(()=>input?.focus({preventScroll:true}),reduce()?0:350)});
 if(authorized())showOpen();else showSealed();
});
})();